import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    CircularProgress,
    Alert
} from '@mui/material';

const Reset = () => {
    const [empCode, setEmpCode] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [enteredOtp, setEnteredOtp] = useState('');
    const [pin, setPin] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);

    const handleSendOtp = async () => {
        if (!empCode) {
            setMessage('Please enter an Employee Code');
            setError(true);
            return;
        }

        setLoading(true);
        setMessage('');
        try {
            const res = await fetch('https://gannondunkerley.in/auth/otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ empCode })
            });

            const data = await res.json();
            if (res.ok) {
                setOtpSent(true);
                setMessage(data.message || 'OTP sent to registered email.');
                setError(false);
            } else {
                setMessage(data.message || 'Failed to send OTP');
                setError(true);
            }
        } catch (err) {
            setMessage('Error sending OTP');
            setError(true);
        }
        setLoading(false);
    };

    const handleVerifyOtp = async () => {
        if (!enteredOtp) {
            setMessage('Please enter OTP');
            setError(true);
            return;
        }

        setLoading(true);
        setMessage('');
        try {
            const res = await fetch('https://gannondunkerley.in/auth/verify-otp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ empCode, enteredOtp })
            });

            const data = await res.json();
            if (res.ok) {
                setPin(data.pin);
                setMessage('OTP verified successfully!');
                setError(false);
            } else {
                setMessage(data.message || 'Failed to verify OTP');
                setError(true);
            }
        } catch (err) {
            setMessage('Error verifying OTP');
            setError(true);
        }
        setLoading(false);
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 5 }} style={{width : "60%"}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Typography variant="h5" fontWeight="bold" textAlign="center">
                    Reset PIN via Email OTP
                </Typography>

                <TextField
                    label="Employee Code"
                    value={empCode}
                    onChange={(e) => setEmpCode(e.target.value)}
                    fullWidth
                    variant="outlined"
                    disabled={otpSent}
                />

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSendOtp}
                    disabled={loading || !empCode || otpSent}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Send OTP'}
                </Button>

                {otpSent && (
                    <>
                        <TextField
                            label="Enter OTP"
                            value={enteredOtp}
                            onChange={(e) => setEnteredOtp(e.target.value)}
                            fullWidth
                            variant="outlined"
                            inputProps={{ maxLength: 6 }}
                        />
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleVerifyOtp}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
                        </Button>
                    </>
                )}

                {pin && (
                    <Alert severity="success">
                        <strong>Generated PIN:</strong> {pin}
                    </Alert>
                )}

                {message && (
                    <Alert severity={error ? 'error' : 'info'}>
                        {message}
                    </Alert>
                )}
            </Box>
        </Container>
    );
};

export default Reset;
